<template>
  <div class="security-wrapper">
    <Title
      title="智慧安防"
      subTitle="Intelligent Security"
      width="910px"
      @showMore="showMore"
    ></Title>
    <div class="content">
      <div class="left-con">
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">安全巡防点</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.pointCount
                  : null
              }}
              <span class="unit">个</span>
            </div>
          </div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">巡防次数</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.guardCount
                  : null
              }}<span class="unit">次</span>
            </div>
          </div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">应急处置</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.callDealCount
                  : null
              }}<span class="unit">次</span>
            </div>
          </div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">消防报警</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.fireControlCount
                  : null
              }}<span class="unit">次</span>
            </div>
          </div>
          <div class="decoration"></div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">今日食品留样</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.foodCount
                  : null
              }}<span class="unit">件</span>
            </div>
          </div>
          <div class="decoration"></div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">实时样板间人数</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.nowHumanNumber
                  : null
              }}<span class="unit">人</span>
            </div>
          </div>
          <div class="decoration"></div>
        </div>
      </div>
      <div class="right-con">
        <div id="out-in"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Commen/Title";
const echarts = require("echarts");
import doubleChart from "./chart/out-in";
import { mapState, mapActions } from "vuex";
import pollingFunction from "@/utils/tools";

export default {
  components: {
    Title,
  },
  computed: {
    ...mapState(["securityData"]),
  },
  data() {
    return {
      pollingST: null,
    };
  },
  async mounted() {
    // 调用轮询;
    if (!this.pollingST) {
      setTimeout(() => {
        this.pollingST = pollingFunction(this.getData, 3000);
      }, 3000);
    }
    await this.getData();
  },
  methods: {
    ...mapActions(["getSecurityData"]),
    async getData() {
      await this.getSecurityData({});
      this.drawChart(this.securityData);
    },
    showMore() {
      this.$store.commit("setServiceDrawer", true);
      this.$store.commit("setCurrentMenu", "security");
    },
    drawChart(data) {
      let arr = [
        data.epidemicPrevention.staff.staffIntoCount,
        data.epidemicPrevention.cultivatorMap.cultivatorIntoCount,
        data.epidemicPrevention.other.visitorIntoCount,
      ];
      let arr2 = [
        data.epidemicPrevention.staff.staffOutCount,
        data.epidemicPrevention.cultivatorMap.cultivatorOutCount,
        data.epidemicPrevention.other.visitorOutCount,
      ];
      this.doubleChart = echarts.init(document.getElementById("out-in"));
      this.doubleChart.setOption(doubleChart(arr, arr2));
    },
  },
  destroyed() {
    clearTimeout(this.pollingST);
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  height: 155px;
}
.left-con {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 55%;
  height: 100%;
  flex-wrap: wrap;
  .num-item {
    display: flex;
    width: 155px;
    height: auto;
    align-items: center;
    flex-wrap: wrap;
    .item-icon {
      width: 40px;
      height: 45px;
      background: url("../../assets/index/security-item.png") no-repeat center
        top;
      background-size: cover;
    }
    .num-con {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .title {
        color: rgb(121, 218, 255);
        font-size: 16px;
        font-weight: normal;
        font-family: "Microsoft Yahei", Arial, "sans-serif";
      }
      .num {
        font-size: 30px;
        color: #fff;
        font-weight: bolder;
        letter-spacing: 0.02em;
        .unit {
          font-size: 15px;
          color: #fff;
          vertical-align: baseline;
        }
      }
    }
    .decoration {
      width: 131px;
      height: 18px;
      background: url("../../assets/index/decoration.png") no-repeat center;
      background-size: contain;
    }
  }
}
.right-con {
  width: 45%;
  height: 100%;
  #out-in {
    width: 100%;
    height: 160px;
  }
}
</style>
